export default __webpack_public_path__ + "1ded655df247e744ddb8157939cf6b76.jpg";